// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/autoplay";
// import { Autoplay } from 'swiper';

// // Import your brand logos
// import RosemcoLogo from "../../assets/BrandLogo/RosemcoLogo.svg";
// import ZoyLogo from "../../assets/BrandLogo/ZoyLogo.svg";
// import CrownLogo from "../../assets/BrandLogo/CrownLogo.svg";

// const BrandCarousel = () => {
//   const brands = [
//     { name: "Crown Farms", logo: CrownLogo },
//     { name: "Rosemco", logo: RosemcoLogo },
//     { name: "Zoy", logo: ZoyLogo },
//   ];

//   return (
//     <div className="py-6">
//       <h2 className="lg:text-2xl mb-4 text-left font-semibold  underline">
//         Brands
//       </h2>
//       <Swiper
//         modules={[Autoplay]}
//         spaceBetween={20}
//         slidesPerView={3}
//         breakpoints={{
//           640: { slidesPerView: 3 },
//           768: { slidesPerView: 3 },
//           1024: { slidesPerView: 3 },
//         }}
//         autoplay={{
//           delay: 2500,
//           disableOnInteraction: false,
//         }}
//         loop={true}
//       >
//         {brands.map((brand, idx) => (
//           <SwiperSlide key={idx}>
//             <div
//               data-aos="zoom-in"
//               data-aos-easing="ease-out-cubic"
//               data-aos-duration="3000"
//               className="flex flex-col items-center justify-center h-28 sm:h-24 md:h-28 lg:h-40  hover:bg-[#FFCD72] transition-all duration-300 rounded-lg p-2 text-center w-full"
//             >
//               <img
//                 src={brand.logo}
//                 alt={brand.name}
//                 data-aos="flip-left"
//                 data-aos-easing="ease-out-cubic"
//                 data-aos-duration="2000"
//                 className="h-24 md:h-24 lg:h-36 w-full object-contain shimmer"
//               />
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//   );
// };

// export default BrandCarousel;
// Import your brand logos
import RosemcoLogo from "../../assets/BrandLogo/RosemcoLogo.svg";
import ZoyLogo from "../../assets/BrandLogo/ZoyLogo.svg";
import CrownLogo from "../../assets/BrandLogo/CrownLogo.svg";

const BrandCarousel = () => {
  const brands = [
    { name: "Crown Farms", logo: CrownLogo },
    { name: "Rosemco", logo: RosemcoLogo },
    { name: "Zoy", logo: ZoyLogo },
  ];

  return (
    <div className="py-6">
      <h2 className="lg:text-2xl mb-4 text-left font-semibold underline">
        Brands
      </h2>

      {/* Grid instead of Swiper */}
      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-4">
        {brands.map((brand, idx) => (
          <div
            key={idx}
            data-aos="zoom-in"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="3000"
            className="flex flex-col items-center justify-center h-28 sm:h-24 md:h-28 lg:h-40 hover:bg-[#FFCD72] transition-all duration-300 rounded-lg p-2 text-center w-full"
          >
            <img
              src={brand.logo}
              alt={brand.name}
              loading="lazy"
              data-aos="flip-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
              className="h-24 md:h-24 lg:h-36 w-full object-contain shimmer"
            />
            {/* Uncomment if you want brand name */}
            {/* <h1 className="text-sm md:text-base font-medium truncate w-full">
              {brand.name}
            </h1> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandCarousel;
